import { useRef } from 'react';
import { AriaButtonProps, useButton } from 'react-aria';
import classNames from 'classnames';

import styles from './FieldButton.module.scss';

export const FieldButton = ({ className, ...props }: AriaButtonProps & { className?: string }) => {
    const ref = useRef<HTMLButtonElement>(null);
    const { buttonProps } = useButton(props, ref);

    return (
        <button {...buttonProps} ref={ref} className={classNames(styles.button, className)}>
            {props.children}
        </button>
    );
};
